export const SELECT_PLAN = "SELECT_PLAN";
export const LOGIN = "LOGIN";
export const SSOLOGIN = "SSOLOGIN"; 
export const ADD_USER_TO_GROUP_SUCCESS = "ADD_USER_TO_GROUP_SUCCESS";
export const ADD_USER_TO_GROUP_REQUEST = "ADD_USER_TO_GROUP_REQUEST";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const ADD_USER_TO_SYS_REQUEST = "ADD_USER_TO_SYS_REQUEST";
export const ADD_USER_TO_SYS_SUCCESS = "ADD_USER_TO_SYS_SUCCESS";

// WEBPACK FOOTER //
// ./src/actions/types.js